export const getFeatureUnit = (cartFeature, fabricatorData, messages, locale, quantity) => {
  const dbFeature = cartFeature.dbFeature;
  if ((fabricatorData.isLowes || fabricatorData.isCaesarStone) && locale === "fr-FR" && messages["transDoc.units_FR." + dbFeature.sharedFeatureName]) {
    if ((messages["transDoc.units_FR." + dbFeature.sharedFeatureName] === "pieds carrés") && dbFeature.unit === "Each") {
      return "unité"
    }
    return messages["transDoc.units_FR." + dbFeature.sharedFeatureName]
  }
  if (dbFeature.unit) {
    let lowercasedUnit = dbFeature.unit.toLowerCase();
    return lowercasedUnit === "each" || lowercasedUnit === "unit"
      ? quantity === 1
        ? messages["quotingTool.featureInfo.defaultQuantity"]
        : messages["quotingTool.featureInfo.defaultQuantityMultiple"]
      : dbFeature.unit
  }
  if (cartFeature.isStoneFeature) {
    return messages["shoppingCart.fetureInCartDefaultQuantitySQFT"]
  }
  return messages["shoppingCart.fetureInCartDefaultQuantity"]
};

export const getCartItemName = (cartFeature, fabricatorData, messages, locale) => {
  const dbFeature = cartFeature.dbFeature;
  if (fabricatorData.isLowes || fabricatorData.isCaesarStone) {
    if (locale === "fr-FR" && messages["transDoc.customDisplayName_FR."+ dbFeature.sharedFeatureName]) {
      return messages["transDoc.customDisplayName_FR."+ dbFeature.sharedFeatureName]
    } else if (locale === "pl-PL" && messages["transDoc.customTranslateName_PL."+ dbFeature.sharedFeatureName]) {
      return messages["transDoc.customTranslateName_PL."+ dbFeature.sharedFeatureName]
    }
  }

  if ((dbFeature.sharedFeatureName === "additionalCartItem.minimumCharge")) {
    if (fabricatorData.isCaesarStone) {
      return `${messages[dbFeature.sharedFeatureName]} (${cartFeature.fromFeatureName})`
    }
    return messages[dbFeature.sharedFeatureName]
  }

  if (!cartFeature.getFeatureName) {
    return cartFeature._customDisplayName || cartFeature.customDisplayName || ""
  }

  return cartFeature.getFeatureName()
};
